import { render, staticRenderFns } from "./MatchStoryline.vue?vue&type=template&id=a2d543f6&scoped=true&"
import script from "./MatchStoryline.vue?vue&type=script&lang=js&"
export * from "./MatchStoryline.vue?vue&type=script&lang=js&"
import style0 from "./MatchStoryline.vue?vue&type=style&index=0&id=a2d543f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d543f6",
  null
  
)

export default component.exports